(function (root) {
  const integer = n => Number.isSafeInteger(n) && n >= 0;
  const key = lines => lines.map(l => `${l.id}:${l.quantity}`).sort().join('|');
  function validateQuantity(variant, quantity) {
    if (!variant || !variant.available || !integer(quantity) || quantity < 1) return false;
    const rule = variant.rule || { min: 1, increment: 1 };
    return quantity >= rule.min && quantity % rule.increment === 0 &&
      (rule.max == null || quantity <= rule.max) &&
      (variant.stock == null || quantity <= variant.stock);
  }
  function selection(draft, catalog) {
    return Object.entries(draft).map(([id, quantity]) => ({ id, quantity, variant: catalog.get(id) }))
      .filter(line => line.variant);
  }
  function summary(draft, catalog) {
    const lines = selection(draft, catalog);
    return { lines, count: lines.reduce((n, l) => n + l.quantity, 0), subtotal: lines.reduce((n, l) => n + l.quantity * l.variant.price, 0) };
  }
  function restore(saved, catalog, currency) {
    if (!saved || saved.currency !== currency || saved.version !== 1 || !saved.draft || Array.isArray(saved.draft) || typeof saved.draft !== 'object') return {};
    return Object.fromEntries(Object.entries(saved.draft).filter(([id, qty]) => validateQuantity(catalog.get(id), qty)));
  }
  function validateQuote(quote, lines, currency, now = Date.now()) {
    if (!quote || quote.status !== 'verified' || quote.currency !== currency || quote.selectionKey !== key(lines) ||
      !quote.revision || !quote.campaignId || !Number.isFinite(quote.expiresAt) || quote.expiresAt <= now ||
      !integer(quote.eligibleCount) || !integer(quote.subtotal) || !integer(quote.total) || !integer(quote.discount) ||
      quote.subtotal - quote.discount !== quote.total || !Array.isArray(quote.gifts) || !Array.isArray(quote.tiers)) return null;
    if (quote.gifts.some(g => !/^\d+$/.test(String(g.id)) || !g.title || !g.size || !integer(g.quantity) || g.quantity < 1 ||
      (g.unitCharge !== undefined && !integer(g.unitCharge)))) return null;
    let previous = 0;
    for (const tier of quote.tiers) {
      if (!integer(tier.min) || tier.min <= previous || !integer(tier.bps) || tier.bps > 10000) return null;
      previous = tier.min;
    }
    return quote;
  }
  function cartDelta(before, after, requested) {
    const identity = line => JSON.stringify([String(line.variant_id || line.id), Object.entries(line.properties || {}).sort(), line.selling_plan_allocation?.selling_plan?.id || null]);
    const quantities = cart => (cart.items || []).reduce((m, l) => m.set(identity(l), (m.get(identity(l)) || 0) + l.quantity), new Map());
    const a = quantities(before), b = quantities(after);
    return requested.map(line => ({ id: line.id, requested: line.quantity, added: (b.get(identity(line)) || 0) - (a.get(identity(line)) || 0) }));
  }
  const api = { key, validateQuantity, selection, summary, restore, validateQuote, cartDelta };
  if (typeof module !== 'undefined') module.exports = api;
  else root.TheManBundleState = api;
})(typeof window === 'undefined' ? globalThis : window);
